import React, { useContext } from "react"
// import { Link } from "gatsby"
// import Link from "gatsby-plugin-transition-link"
import Link from "gatsby-plugin-transition-link"

import LocaleContext from "../localeContext"
import locales from "../i18n/"

export default ({
  to,
  // entry = { length: 0, delay: 0 },
  // exit = { length: 0, delay: 0 },
  ...props
}) => {
  const { locale } = useContext(LocaleContext)

  const isIndex = to === "/"

  const path = locales[locale].default ? to : `${locales[locale].path}${isIndex ? "" : to}`

  // return <TransitionLink entry={entry} exit={exit} {...props} to={path} />
  return <Link to={path} {...props} />
}
